import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FattyLiverPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Fatty Liver</h1>
        <section className="mb-8">
          <p>Fatty liver disease occurs when excess fat builds up in the liver, affecting its function. It's often linked to lifestyle factors and can lead to more serious health issues if left untreated. Natural therapies can help restore liver health and prevent complications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor diet (high in fats and sugars)</li>
            <li>Obesity</li>
            <li>Diabetes</li>
            <li>Excessive alcohol consumption</li>
            <li>Sedentary lifestyle</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Fatigue</li>
            <li>Discomfort in the upper right abdomen</li>
            <li>Unexplained weight loss</li>
            <li>Weakness</li>
            <li>Mild jaundice (in advanced cases)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use liver-supporting herbs, dietary guidance, and holistic therapies to reduce fat accumulation and promote liver regeneration. Our approach is gentle, effective, and tailored to your needs.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Supports natural liver detoxification</li>
            <li>Reduces inflammation</li>
            <li>Promotes healthy metabolism</li>
            <li>No harsh side effects</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a balanced, low-fat diet</li>
            <li>Exercise regularly</li>
            <li>Limit alcohol intake</li>
            <li>Maintain a healthy weight</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can fatty liver be reversed?</strong>
            <p>A: Yes, with lifestyle changes and natural support, the liver can heal.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: How long does it take to see improvement?</strong>
            <p>A: Many patients notice better energy and liver function within months.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Is this safe with other medications?</strong>
            <p>A: Yes, our approach is designed to complement your doctor's plan.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Take care of your liver—book a natural wellness consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default FattyLiverPage; 